import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { NftMoleculeReatom } from "../store/nft-store.reatom"

export const useOfferItemsReatom = () => {
  const { nftOffersQueryParamsAtom } = useMolecule(NftMoleculeReatom)

  const queryParams = nftOffersQueryParamsAtom()
  const nftOffersQuery = useSuspenseInfiniteQuery(queryParams)

  const queryResult = useMemo(
    () => ({
      ...nftOffersQuery,
      pages: nftOffersQuery.data.pages.map((page) => ({
        items: page.offers,
      })),
    }),
    [nftOffersQuery],
  )

  return useInfiniteTableItems(queryResult)
}
